export default "__VITE_ASSET__CTMHE9XP__"